import request from "@/utils/request";

export function pollenProcessing1Get(params) {
    return request({
        url: "/api/services/app/PollenProcessing1/Get",
        method: "GET",
        params
    });
}

export function pollenProcessing1CreateWithImages(data) {
    return request({
        url: "/api/services/app/PollenProcessing1/CreateWithImages",
        method: "post",
        data
    });
}

export function pollenProcessing1CreateMany(data) {
    return request({
        url: "/api/services/app/PollenProcessing1/CreateMany",
        method: "POST",
        data
    });
}

export function pollenProcessing1Update(data) {
    return request({
        url: "/api/services/app/PollenProcessing1/Update",
        method: "put",
        data
    });
}

export function pollenProcessing1Delete(params) {
    return request({
        url: "/api/services/app/PollenProcessing1/Delete",
        method: "delete",
        params
    });
}

export function pollenProcessing1DeleteMany(data) {
    return request({
        url: "/api/services/app/PollenProcessing1/DeleteMany",
        method: "post",
        data
    });
}




// WEBPACK FOOTER //
// ./src/api/pollen_processing_1.js